// This file was automatically generated from ptdata.prenatalFlowsheets.html.
// Please don't edit this file by hand.

goog.provide('el8.template.ptdata.prenatalFlowsheets');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.prenatalFlowsheets.patientSummary = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  var fList21860 = opt_data.flowsheets;
  var fListLen21860 = fList21860.length;
  for (var fIndex21860 = 0; fIndex21860 < fListLen21860; fIndex21860++) {
    var fData21860 = fList21860[fIndex21860];
    el8.template.ptdata.prenatalFlowsheets.summary(fData21860, output);
    output.append((! (fIndex21860 == fListLen21860 - 1)) ? ', ' : '');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.prenatalFlowsheets.summary = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.endDate) ? '<span class="el8PrenatalFlowsheetCompleted">Completed: ' : '', (opt_data.hasDraft) ? 'In Progress: ' : '', soy.$$escapeHtml(opt_data.name), ' (EDD: ', soy.$$escapeHtml(opt_data.edd), ')', (opt_data.endDate) ? '</span>' : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.prenatalFlowsheets.feedSummary = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.isRA) ? 'In Progress: ' : '', 'Prenatal visit on ', (soy.$$escapeHtml(opt_data.visitMeasurements.date)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.visitMeasurements.date)) : ''), ' (', (opt_data.flowsheet.endDate) ? 'Completed ' : '', 'Flowsheet: ', soy.$$escapeHtml(opt_data.flowsheet.name), ')');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.prenatalFlowsheets.feedSummaryDetails = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.visitMeasurements.weeksGest && opt_data.visitMeasurements.weeksGest.length) ? 'GA: ' + soy.$$escapeHtml(opt_data.visitMeasurements.weeksGest) + ' ' : '', (opt_data.visitMeasurements.weight && opt_data.visitMeasurements.weight.length) ? 'Wt: ' + soy.$$escapeHtml(opt_data.visitMeasurements.weight) + ' ' : '', (opt_data.visitMeasurements.bpS && opt_data.visitMeasurements.bpS.length || opt_data.visitMeasurements.bpD && opt_data.visitMeasurements.bpD.length) ? 'BP: ' + ((opt_data.visitMeasurements.bpS && opt_data.visitMeasurements.bpS.length) ? soy.$$escapeHtml(opt_data.visitMeasurements.bpS) : '') + '/' + ((opt_data.visitMeasurements.bpD && opt_data.visitMeasurements.bpD.length) ? soy.$$escapeHtml(opt_data.visitMeasurements.bpD) : '') + ' ' : '', (opt_data.visitMeasurements.urineAlb && opt_data.visitMeasurements.urineAlb.length || opt_data.visitMeasurements.urineGlu && opt_data.visitMeasurements.urineGlu.length) ? 'Urine: ' + ((opt_data.visitMeasurements.urineAlb && opt_data.visitMeasurements.urineAlb.length) ? soy.$$escapeHtml(opt_data.visitMeasurements.urineAlb) : '') + '/' + ((opt_data.visitMeasurements.urineGlu && opt_data.visitMeasurements.urineGlu.length) ? soy.$$escapeHtml(opt_data.visitMeasurements.urineGlu) : '') + ' ' : '', (opt_data.visitMeasurements.fetalMvmt && opt_data.visitMeasurements.fetalMvmt.length) ? 'FM: ' + soy.$$escapeHtml(opt_data.visitMeasurements.fetalMvmt) + ' ' : '', (opt_data.visitMeasurements.pretermSymp && opt_data.visitMeasurements.pretermSymp.length) ? 'PTL Sx: ' + soy.$$escapeHtml(opt_data.visitMeasurements.pretermSymp) + ' ' : '', (opt_data.visitMeasurements.fhr && opt_data.visitMeasurements.fhr.length) ? 'FHR: ' + soy.$$escapeHtml(opt_data.visitMeasurements.fhr) + ' ' : '', (opt_data.visitMeasurements.fundlHt && opt_data.visitMeasurements.fundlHt.length) ? 'F. Ht: ' + soy.$$escapeHtml(opt_data.visitMeasurements.fundlHt) + ' ' : '', (opt_data.visitMeasurements.pres && opt_data.visitMeasurements.pres.length) ? 'Pres: ' + soy.$$escapeHtml(opt_data.visitMeasurements.pres) + ' ' : '', (opt_data.visitMeasurements.edema && opt_data.visitMeasurements.edema.length) ? 'Edema: ' + soy.$$escapeHtml(opt_data.visitMeasurements.edema) + ' ' : '', (opt_data.visitMeasurements.crvxExamDil && opt_data.visitMeasurements.crvxExamDil.length || opt_data.visitMeasurements.crvxExamDff && opt_data.visitMeasurements.crvxExamDff.length || opt_data.visitMeasurements.crvxExamSta && opt_data.visitMeasurements.crvxExamSta.length) ? 'Crvx: ' + ((opt_data.visitMeasurements.crvxExamDil && opt_data.visitMeasurements.crvxExamDil.length) ? soy.$$escapeHtml(opt_data.visitMeasurements.crvxExamDil) : '') + '/' + ((opt_data.visitMeasurements.crvxExamDff && opt_data.visitMeasurements.crvxExamDff.length) ? soy.$$escapeHtml(opt_data.visitMeasurements.crvxExamDff) : '') + '/' + ((opt_data.visitMeasurements.crvxExamSta && opt_data.visitMeasurements.crvxExamSta.length) ? soy.$$escapeHtml(opt_data.visitMeasurements.crvxExamSta) : '') + ' ' : '', (opt_data.visitMeasurements.nextAppt && opt_data.visitMeasurements.nextAppt.length) ? 'F/U: ' + soy.$$escapeHtml(opt_data.visitMeasurements.nextAppt) + ' ' : '', (opt_data.visitMeasurements.comments && opt_data.visitMeasurements.comments.length) ? 'Notes: ' + soy.$$escapeHtml(opt_data.visitMeasurements.comments) : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.prenatalFlowsheets.chartFeedItemText = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('Flowsheet Name: ', soy.$$escapeHtml(opt_data.flowsheet.name));
  if (!opt_sb) return output.toString();
};
